<template>
  <div id="inviter">
    <div class="img" :style="$bgd(img)" />
    <p>
      <b>{{ name }}</b>
      <span>邀请你体验欧美外教真人直播课</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Inviter",
  props: ["name", "img"],
}
</script>
<style lang="scss" scoped>
@import "./style.scss";

#inviter {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 10px 0;
  .img {
    $size: 35px;
    min-width: $size;
    min-height: $size;
    border-radius: 50%;
    margin-right: 5px;
  }
  p {
    @include avenir();
    font-size: 0.9rem;
    b {
      @include avenir-demi();
    }
    span {
      opacity: 0.6;
    }
  }
}
</style>
